var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var LocalizationRepository_1;
import { IConfigurationRepositoryType } from '../../../Domain/UseCases/Configuration/IConfigurationRepository';
import { IAPIHTTPDataSourceType } from '../../DataSource/APIHTTPDataSource/IAPIHTTPDataSource';
import { IStorageDataSourceType } from '../../DataSource/StorageDataSource/IStorageDataSource';
import { StateMap } from '../../../Domain/DTOs/Module/ModuleDTO';
import { ICacheDataSourceType } from '../../DataSource/CacheDataSource/ICacheDataSource';
import { Observable } from '../../Observable/Observable';
import { EventBus } from '../../EventBus/EventBus';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { CoreConfig } from '../../../CoreConfig';
let LocalizationRepository = LocalizationRepository_1 = class LocalizationRepository {
    constructor(configurationRepository, dataSource, storageDataSource, cacheDataSource) {
        this.configurationRepository = configurationRepository;
        this.dataSource = dataSource;
        this.storageDataSource = storageDataSource;
        this.cacheDataSource = cacheDataSource;
        this.locale = new Observable('');
        this.countryCode = new Observable('');
        this.localizationMap = new Map();
        this.language = new Observable('');
        this.languages = new Observable([]);
        const rtl_languages = ['ar', 'arc', 'dv', 'fa', 'ha', 'he', 'khw', 'ks', 'ku', 'ps', 'ur', 'yi'];
        const directions = ['rtl', 'ltr'];
        this.configurationRepository.configuration.observe(this, value => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const languages = (((_b = (_a = value.application) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.languages) || []).map((language) => {
                if (typeof language.selected !== 'boolean') {
                    language.selected = false;
                }
                if (!language.text_direction) {
                    language.text_direction = rtl_languages.includes(language.code)
                        ? 'rtl'
                        : 'ltr';
                }
                if (!directions.includes(language.text_direction)) {
                    language.text_direction = 'ltr';
                }
                return language;
            });
            this.languages.next(languages);
            this.countryCode.next((_d = (_c = value.application) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.country_code);
            this.locale.next((_f = (_e = value.application) === null || _e === void 0 ? void 0 : _e.settings) === null || _f === void 0 ? void 0 : _f.locale);
            Date.setGlobalLocale((_h = (_g = value.application) === null || _g === void 0 ? void 0 : _g.settings) === null || _h === void 0 ? void 0 : _h.locale);
            const applicationModule = value.application || {};
            const customerModule = value.customer || {};
            Object.entries(value).forEach(([moduleName, module]) => {
                if (!module) {
                    return;
                }
                if (typeof module !== 'object' || Array.isArray(module)) {
                    return;
                }
                if (!this.localizationMap.has(moduleName)) {
                    this.localizationMap.set(moduleName, new EventBus());
                }
                Object.entries(module.components || {}).forEach(([componentName, localization]) => {
                    var _a;
                    if (!localization || typeof localization !== 'object' || Array.isArray(localization)) {
                        return;
                    }
                    const texts = Object.assign(Object.assign(Object.assign(Object.assign({}, applicationModule.texts), (_a = customerModule.texts) === null || _a === void 0 ? void 0 : _a.general), module.texts), localization);
                    this.localizationMap.get(moduleName).get(componentName).next(texts);
                });
            });
        });
    }
    getErrorPopUpLocalization() {
        var _a, _b, _c, _d, _e, _f;
        const localization = Object.assign(Object.assign({}, (_c = (_b = (_a = this.configurationRepository.configuration.value) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.general), (_f = (_e = (_d = this.configurationRepository.configuration.value) === null || _d === void 0 ? void 0 : _d[CoreConfig.moduleName.toLowerCase()]) === null || _e === void 0 ? void 0 : _e.components) === null || _f === void 0 ? void 0 : _f.error_pop_up);
        return Object.assign(Object.assign({}, localization), { title: (localization === null || localization === void 0 ? void 0 : localization.title) || (localization === null || localization === void 0 ? void 0 : localization.uh_oh) || 'Uh oh!' });
    }
    getImportLocalization() {
        var _a, _b, _c, _d, _e, _f;
        const text = Object.assign(Object.assign({}, (_c = (_b = (_a = this.configurationRepository.configuration.value) === null || _a === void 0 ? void 0 : _a.customer) === null || _b === void 0 ? void 0 : _b.texts) === null || _c === void 0 ? void 0 : _c.general), (_f = (_e = (_d = this.configurationRepository.configuration.value) === null || _d === void 0 ? void 0 : _d[CoreConfig.moduleName.toLowerCase()]) === null || _e === void 0 ? void 0 : _e.components) === null || _f === void 0 ? void 0 : _f.import);
        return {
            camera: text.camera || 'Camera',
            gallery: text.gallery || 'Gallery',
            description: text.description || text.where_do_you_want_to_get_photos_to_attach || 'Where do you want to get photos to attach?'
        };
    }
    getDefaultLanguage() {
        return this.cacheDataSource.getCache(StateMap.language).data;
    }
    getStorageLanguage() {
        return this.storageDataSource.get(LocalizationRepository_1.language_key).then(val => val || '');
    }
    getLanguages() {
        return this.languages;
    }
    getLanguage() {
        return this.language;
    }
    setLanguage(language) {
        this.dataSource.setLanguage(language);
        this.storageDataSource.set(LocalizationRepository_1.language_key, language);
        return this.language.next(language);
    }
    getComponentLocalization(moduleName, componentName) {
        if (!this.localizationMap.has(moduleName)) {
            this.localizationMap.set(moduleName, new EventBus());
        }
        const componentLocalization = this.localizationMap.get(moduleName).get(componentName);
        if (!componentLocalization.value) {
            componentLocalization.next({});
        }
        return componentLocalization;
    }
    getLocale() {
        return this.locale;
    }
    getCountryCode() {
        return this.countryCode;
    }
};
LocalizationRepository.language_key = 'language';
LocalizationRepository = LocalizationRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IConfigurationRepositoryType)),
    __param(1, inject(IAPIHTTPDataSourceType)),
    __param(2, inject(IStorageDataSourceType)),
    __param(3, inject(ICacheDataSourceType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], LocalizationRepository);
export { LocalizationRepository };
